import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/home.css';
import { FiHeart, FiGlobe, FiSmile, FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import logo from '../assets/sanjeevani.jpeg';

function Home() {
  return (
    <div className="home-container">
      {/* Navigation */}
      <nav className="home-nav">
        <div className="nav-brand">
          <img src={logo} alt="Sanjeevani" style={{ width: "40px", height: "40px", borderRadius: "6px", border: "1px solid rgba(255,255,255,0.2)" }} />
          <span className="brand-name" style={{ fontSize: "1.5rem", fontWeight: "bold", color: "white", letterSpacing: "0.5px" }}>Sanjeevani</span>
        </div>
        <div className="nav-actions">
          <Link to="/login" className="btn-text" style={{ fontSize: "0.95rem", color: "rgba(255, 255, 255, 0.85)" }}>Login</Link>
          <Link to="/signup" className="btn-solid" style={{ padding: "6px 16px", fontSize: "0.95rem", background: "white", color: "#764ba2", border: "1px solid rgba(255,255,255,0.7)" }}>Sign Up Free</Link>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="hero-section" style={{ padding: "80px 6%" }}>
        <main className="home-content">
          <section className="home-text">
            <h1>Don't Let Good Food Go To Waste. <br />Share It With The World.</h1>
            <p>
              A smart shelf-life and food sharing platform that connects donors,
              receivers, and admins to make sure good food never goes to waste.
            </p>

            <div className="cta-group" style={{ justifyContent: "center", marginTop: "32px", width: "100%" }}>
              <Link to="/signup" className="btn-solid large">Get Started</Link>
              <Link to="/login" className="btn-outline large">I have an account</Link>
            </div>
          </section>
        </main>
      </header>

      {/* Why Donate Section */}
      <section className="why-donate py-section">
        <div className="section-title">
          <h2>Why Donate Through Sanjeevani?</h2>
          <p>Your single meal donation creates a chain of positive impacts on society and the planet.</p>
        </div>

        <div className="grid-cards-3">
          <div className="info-card">
            <div className="icon-wrap green"><FiSmile /></div>
            <h3>Feed The Hungry</h3>
            <p>Millions of people go to bed hungry every day. Your surplus food can become someone's only assured meal for the day.</p>
          </div>
          <div className="info-card">
            <div className="icon-wrap green"><FiGlobe /></div>
            <h3>Save Our Planet</h3>
            <p>Food in landfills generates harmful greenhouse gases (Methane). Donating food directly reduces your carbon footprint.</p>
          </div>
          <div className="info-card">
            <div className="icon-wrap green"><FiHeart /></div>
            <h3>Spread Kindness</h3>
            <p>Donation builds a compassionate community. It brings people together to share resources, happiness, and hope.</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works py-section">
        <div className="section-title">
          <h2>How Sanjeevani Works?</h2>
          <p>A simple, secure, and fast process to share eatable food.</p>
        </div>

        <div className="grid-cards-3">
          <div className="info-card">
            <div className="icon-wrap green"><span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>1</span></div>
            <h3>Share Eatable Food</h3>
            <p>As a Donor, simply log in and list any good, consumable food you wish to provide, along with its quantity and expiry details.</p>
          </div>
          <div className="info-card">
            <div className="icon-wrap green"><span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>2</span></div>
            <h3>Browse & Reserve</h3>
            <p>Receivers can browse the live dashboard to find available food items nearby and securely reserve them with a single click.</p>
          </div>
          <div className="info-card">
            <div className="icon-wrap green"><span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>3</span></div>
            <h3>Secure Handover</h3>
            <p>The Receiver visits the donor's location. The handover is securely verified via an SMS OTP sent to the receiver's mobile number.</p>
          </div>
        </div>
      </section>

      {/* Time Limits Section */}
      <section className="time-limits-section py-section">
        <div className="section-title">
          <h2>Reservation Time Limits</h2>
          <p>Strict deadlines ensure food reaches the needy quickly without waiting indefinitely.</p>
        </div>

        <div className="grid-cards-3" style={{ justifyContent: "center", display: "flex", gap: "30px", flexWrap: "wrap", maxWidth: "900px", margin: "0 auto" }}>
          <div className="info-card" style={{ flex: "1 1 300px", borderTop: "4px solid #4caf50", textAlign: "center" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🥗</div>
            <h3 style={{ color: "#2e7d32", marginBottom: "5px" }}>Fresh Food</h3>
            <div style={{ display: "inline-block", background: "#e8f5e9", color: "#2e7d32", padding: "5px 15px", borderRadius: "20px", fontWeight: "bold", marginBottom: "15px" }}>2 Hours Limit</div>
            <p>Freshly prepared meals and perishables must be collected within 2 hours of reservation.</p>
          </div>
          
          <div className="info-card" style={{ flex: "1 1 300px", borderTop: "4px solid #1976d2", textAlign: "center" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🥫</div>
            <h3 style={{ color: "#1565c0", marginBottom: "5px" }}>Stored Food</h3>
            <div style={{ display: "inline-block", background: "#e3f2fd", color: "#1565c0", padding: "5px 15px", borderRadius: "20px", fontWeight: "bold", marginBottom: "15px" }}>24 Hours Limit</div>
            <p>Packaged and non-perishable items must be collected within 24 hours of reservation.</p>
          </div>
        </div>
        
        <div style={{ textAlign: "center", marginTop: "35px" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(255, 240, 240, 0.95)", border: "1px solid rgba(255, 205, 210, 0.8)", color: "#c62828", padding: "12px 24px", borderRadius: "8px", fontWeight: "600", fontSize: "0.95rem", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)" }}>
            <span style={{ fontSize: "1.2rem" }}>⚠️</span> If not collected in time, the item automatically becomes available for others!
          </div>
        </div>
      </section>

      {/* User Roles / Who Are We? */}
      <section className="user-roles py-section">
        <div className="section-title">
          <h2>Who Can Join Sanjeevani?</h2>
          <p>Everyone has a part to play in sharing food and saving lives.</p>
        </div>

        <div className="grid-cards-3 roles-grid">
          <div className="role-box">
            <h4><FiCheckCircle className="check-icon" /> Food Donors</h4>
            <p>Shopkeepers, restaurant owners, event organizers, or any individual who wants to provide fresh and eatable food can become a donor.</p>
          </div>
          <div className="role-box">
            <h4><FiCheckCircle className="check-icon" /> Receivers</h4>
            <p>Any normal user, NGO, or volunteer can register as a receiver to collect food for themselves or to help distribute it to those in need.</p>
          </div>
          <div className="role-box">
            <h4><FiCheckCircle className="check-icon" /> Platform Admins</h4>
            <p>Admins maintain a safe platform by monitoring activity, managing user feedback, and resolving issues to ensure a smooth experience for everyone.</p>
          </div>
        </div>
      </section>

      {/* Call to action Section */}
      <section className="ready-cta-section py-section" style={{ textAlign: "center", background: "transparent" }}>
        <h2 style={{ fontSize: "2.5rem", marginBottom: "20px", color: "#333", fontWeight: "800", textShadow: "0 2px 14px rgba(255, 255, 255, 0.9)" }}>Ready To Make a Difference?</h2>
        <Link to="/signup" className="btn-solid large">Join Sanjeevani Now</Link>
      </section>

      {/* Footer */}
      <footer className="simple-footer">
        <div className="footer-copyright">
          <p style={{ color: "#ffffff", fontSize: "1.05rem", margin: 0 }}>&copy; {new Date().getFullYear()} Sanjeevani Food Donation Platform. Designed to save food and lives.</p>
          <p style={{ color: "#ede7f6", fontSize: "1rem", margin: "8px 0 0 0", fontWeight: "500", letterSpacing: "0.5px" }}>Developed by - Prince Raj</p>
        </div>
      </footer>
    </div>
  );
}

export default Home;
